const { convertCompatFormatter, Group, applyFormatterResultToCellNode } = Slick;export {
     convertCompatFormatter, Group, applyFormatterResultToCellNode
};